import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesProaAudit } from '../../models/atualizacoes-proa-audit';
import { Proa } from '../processos/models/proa';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { ProaService } from '../processos/services/proa.service';
import { ProjetoCadastroService } from '../../services/projeto-cadastro.service';

@Component({
  selector: 'app-detalhe-projeto-proa-edit',
  templateUrl: './detalhe-projeto-proa-edit.component.html',
  styleUrls: ['./detalhe-projeto-proa-edit.component.scss']
})
export class DetalheProjetoProaEditComponent extends BaseFormComponent<Proa> implements OnInit {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  proasArray: Proa[];
  actionLabel: string = 'Editar';
  comboVinculos: any;
  tipoLinks: any;
  form: FormGroup;
  audit: AtualizacoesProaAudit;

  constructor(
    private myService: ProaService,
    public maskService: MaskService,
    private toastr: ToastrService,
    public activatedRoute: ActivatedRoute,
    private projectService: ProjetoCadastroService,
    private fb: FormBuilder,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.comboVinculos = this.activatedRoute.snapshot.data['comboVinculos'];
      this.proasArray = this.activatedRoute.snapshot.data['proas'];
      this.tipoLinks = [{ id: 1, label: 'Entrega' }, { id: 2, label: 'Indicador' }, { id: 3, label: 'IRFE' }, { id: 4, label: 'IRCP' }];
      this.addSub(
        this.projectService.getById(this.idProjeto).subscribe((res) => {
          if (!res.full_blocked) {
            this.initForm();
          } else {
            this.toastr.error('Não é permitido editar PROAS em projetos Bloqueados');
            this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'proa']);
          }
        })
      );
      this.loaded();
    });
    
  }

  initForm() {
    this.form = this.fb.group({
      proas: this.fb.array([])
    });

    if (this.proasArray) {
      this.proasArray.forEach(proa => {
        let links = [];
        if (proa.links.length) {
          proa.links.forEach(link => {
            links.push(this.fb.group({
              type_link: [link.type, Validators.required],
              child_id: [link.id, Validators.required]
            }));
          });
        }
        let item = {
          proa_id: [this.maskService.formatarNumProa(proa.proa_id), [Validators.required, Validators.minLength(17)]],
          proa_description: proa.proa_description,
          links: this.fb.array(links)
        };
        this.proas().push(this.fb.group(item));
      });

      this.audit = {
        pf_id: this.idProjeto
      };
    }
  }

  proas(): FormArray {
    return this.form.get('proas') as FormArray;
  }

  newProa(): FormGroup {
    return this.fb.group({
      proa_id: ['', [Validators.required, Validators.minLength(17)]],
      proa_description: [''],
      links: this.fb.array([])
    });
  }

  addProa() {
    this.proas().push(this.newProa());
  }

  removeProa(index: number) {
    this.proas().removeAt(index);
  }

  links(index: number): FormArray {
    return this.proas()
      .at(index)
      .get('links') as FormArray;
  }

  newLink(): FormGroup {
    return this.fb.group({
      type_link: [null, Validators.required],
      child_id: [null, Validators.required]
    });
  }

  addLink(index: number) {
    this.links(index).push(this.newLink());
  }

  removeLink(proaIndex: number, linkIndex: number) {
    this.links(proaIndex).removeAt(linkIndex);
  }

  getComboLink(proaIndex: number, linkIndex: number): any[] {
    let links = this.links(proaIndex);
    let link = links.at(linkIndex);
    let tipo = link.value['type_link'];
    if (this.comboVinculos[tipo]) {
      return this.comboVinculos[tipo];
    }
    return [];
  }

  changeTipoVinculo(proaIndex: number, linkIndex: number) {
    let links = this.links(proaIndex);
    let link = links.at(linkIndex);
    link.patchValue({ child_id: null });
  }

  voltar() {
    this.navigation.back(['projetos', 'projeto', this.idProjeto, 'proa']);
  }

  salvar() {
    if (this.form.valid) {
      this.loading();
      this.addSub(
        this.myService.update(this.form.value.proas, this.idProjeto).subscribe({
          next: (res) => {
            this.msgSuccess('Proas vinculados com sucesso!')
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
    }
  }

  maskProa(e, proaIndex: number) {
    let proa_id = this.maskService.formatarNumProa(e.target.value);
    let proa = this.proas().at(proaIndex);
    proa.patchValue({ proa_id: proa_id });
  }
}
